export default __webpack_public_path__ + "static/nz-2b9e7813d700cff09db546eb0d405ad6.png";